import { Link } from 'react-router-dom'
import { APP_STORE_URL } from './AppStoreButtons'

export function TopNav() {
  return (
    <nav className="sticky top-0 w-full z-50 bg-surface/60 backdrop-blur-xl shadow-[0_40px_60px_-15px_rgba(231,229,229,0.06)]">
      <div className="flex justify-between items-center section-x py-3 sm:py-4 max-w-7xl mx-auto">
        <Link
          to="/"
          className="text-xl font-headline font-bold tracking-[0.02em] text-on-surface hover:text-primary transition-colors"
        >
          gymAhead
        </Link>
        <div className="flex items-center gap-3">
          <a
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Download on the App Store"
            className="bg-primary text-on-primary font-headline font-bold px-4 sm:px-5 py-2 rounded-full active:scale-95 transition-transform text-xs sm:text-sm whitespace-nowrap"
          >
            Get the App
          </a>
        </div>
      </div>
    </nav>
  )
}
